import { useEffect, useState } from "react";
import { api } from "../api/client";
import type { Revision } from "../api/types";
import { useToast, errText } from "../components/ui";

export default function Revisions() {
  const notify = useToast();
  const [rows, setRows] = useState<Revision[]>([]);
  useEffect(() => {
    api.revisions().then(setRows).catch((e) => notify({ kind: "error", msg: errText(e) }));
  }, []);
  return (
    <div>
      <div className="panel">
        <div className="card-head"><span className="title">应用历史（版本快照）</span></div>
        {rows.length === 0 && <div className="muted">暂无记录</div>}
        {rows.map((r) => (
          <div className="card" key={r.id}>
            <div className="card-head">
              <span className="title">#{r.id}</span>
              <span className={`badge ${r.state === "applied" ? "on" : r.state === "failed" ? "err" : "off"}`}>{r.state}</span>
              <span className="muted">{r.applied_at || r.created_at}</span>
              <span className="spacer" />
              <span className="mono muted">{r.note}</span>
            </div>
            {r.error && <div className="err" style={{ fontSize: 12, marginTop: 6 }}>{r.error}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
